import React from "react";
import Typography from "@material-ui/core/Typography";
import {exportacionesResources} from "../endpoints";
import Grid from "@material-ui/core/Grid";
import CardExportar from "../components/CardExportar";
import Button from "@material-ui/core/Button";
import SvgIcon from "@material-ui/core/SvgIcon";
import useToken from "../useToken";
import SnackbarAlert from "../components/SnackbarAlert";
import DialogExportar from "../components/DialogExportar";
import {Card, CardActions, CardHeader} from "@material-ui/core";
import { Redirect } from "react-router-dom";

class Exportaciones extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            exportaciones:[],
            cliente:null,
            open: false,
            message: '',
            severity: '',
            openSnack: false,
        }
    }

    handleClose = () =>{
        this.setState({open:false})
    }

    refrescar =(estado,severity) =>{
        this.setState({ open: false, openSnack: false})
        if (severity){
            this.setState({
                open: false,
                openSnack: true,
                message: estado,
                severity: severity
            })
        }
    }
    obtenerExportaciones = () =>{
        exportacionesResources.getExportaciones().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            this.setState({exportaciones:result})
        }).catch(error=> {
            console.log(error)
        });
    }

    componentDidMount() {
        const verifyFolio = useToken.verifyToken()
        if(!verifyFolio){
            this.props.history.push('/inventarios');
        }
        else{
            this.obtenerExportaciones()
            let datos_inv = useToken.getDatos()
            this.setState({cliente:datos_inv.app})
        }
    
    }

    enviarDatosReportes =(nombre)=>{
        let params = ""
        this.setState({open: true, reporte: nombre, params: params,openSnack:false})
    }

    render() {
        const verifyFolio = useToken.verifyToken()

        if(!verifyFolio){
            return <Redirect to="/inventarios"/>
        }
        else{
            return(
                <div>
                    <Typography variant="h4" gutterBottom>
                        Exportaciones
                    </Typography>

                        {(this.state.cliente === "walmart" || this.state.cliente === "walmart_parciales") &&
                            <Grid container direction="row" alignItems="center" spacing={2}>
                                <Grid item>
                                    <Card style={{backgroundColor: "#90caf9", display: 'inline-grid'}}>
                                        <CardHeader title="HIGH DOLLAR"/>
                                        <CardActions>
                                            <Button startIcon={ <SvgIcon>
                                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                            </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("high_dollar_walmart")}>
                                                EXPORTAR</Button>
                                        </CardActions>
                                    </Card></Grid>
                                <Grid item>
                                    <Card style={{backgroundColor: "#90caf9",display: 'inline-grid'}}>
                                        <CardHeader title="MANDATORIOS"/>
                                        <CardActions>
                                            <Button startIcon={ <SvgIcon>
                                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                            </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("mandatorio")}>
                                                EXPORTAR</Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item>
                                    <Card style={{backgroundColor: "#90caf9",display: 'inline-grid'}}>
                                        <CardHeader title="RNR"/>
                                        <CardActions>
                                            <Button startIcon={ <SvgIcon>
                                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                            </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("rnr")}>
                                                EXPORTAR</Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item>
                                    <Card style={{backgroundColor: "#90caf9",display: 'inline-grid'}}>
                                        <CardHeader title="PORTADA SIC"/>
                                        <CardActions>
                                            <Button startIcon={ <SvgIcon>
                                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                            </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("portada_sic")}>
                                                EXPORTAR</Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item>
                                    <Card style={{backgroundColor: "#90caf9",display: 'inline-grid'}}>
                                        <CardHeader title="RESUMEN Y DETALLE POR PROGRAMA"/>
                                        <CardActions>
                                            <Button startIcon={ <SvgIcon>
                                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                            </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("resumen_detalle_programas_walmart")}>
                                                EXPORTAR</Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            </Grid>}
                        <Grid container direction="row" alignItems="center" spacing={2}>
                            <Grid item>
                                <Card style={{backgroundColor: "#90caf9",display: 'inline-grid'}}>
                                    <CardHeader title="SIC"/>
                                    <CardActions>
                                        <Button startIcon={ <SvgIcon>
                                            <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                        </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("sic")}>
                                            EXPORTAR</Button>
                                    </CardActions>
                                </Card>
                            </Grid>
                            {this.state.exportaciones.map((exportacion)=>{
                                return <Grid item key={exportacion.nombre}>
                                    <CardExportar title={exportacion.nombre} endpoint={exportacion.endpoint}/>
                                </Grid>
                            })}
                        </Grid>

                    {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                    {this.state.open? <DialogExportar reporte={this.state.reporte} origen={'otro'} params={this.state.params} refrescar={this.refrescar} handleClose={this.handleClose}/> : null}
                </div>
            )
        }
    }
}
export default Exportaciones